import { EpimsBaseEntityDto } from './epim-base.dto';
export class SeismicCommunityDto extends EpimsBaseEntityDto {
  CommunityName: string;
  LgaId: string;
  BranchCode: string;
  SubscriptionUserId: string;
  Version: number;
}
